<template>
    <div>
        <el-row class="search-add" :gutter="10">
            <el-col :span="4">
                <el-input placeholder="设备编号" v-model="devId"></el-input>
            </el-col>
            <el-col :span="4">
                <el-input placeholder="固件版本号" v-model="firmVersion"></el-input>
            </el-col>
            <el-col :span="4">
                <el-select v-model="firmType" placeholder="请选择固件类型">
                    <el-option value="" label="请选择固件类型"></el-option>
                    <el-option v-for="x in typeList" :key="x" :value="x" :label="x"></el-option>
                </el-select>
            </el-col>
            <el-col :span="12">
                <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
            </el-col>
        </el-row>

        <el-table :data="data" border stripe style="width: 100%">
            <el-table-column prop="devId" label="设备编号">
            </el-table-column>
            <el-table-column prop="name" label="设备名称">
            </el-table-column>
            <el-table-column prop="romModel" label="固件名称">
            </el-table-column>
            <el-table-column prop="firmType" label="固件类型">
            </el-table-column>
            <el-table-column prop="firmVersion" label="固件版本">
            </el-table-column>
            <el-table-column prop="upVersion" label="升级版本">
            </el-table-column>
            <el-table-column prop="lasttime" label="升级状态">
                <template slot-scope="scope">
                    {{scope.row.upStatus | status}}
                </template>
            </el-table-column>
            <el-table-column prop="upDate" label="升级时间">
            </el-table-column>
        </el-table>
        <div class="tableDel-Page">
            <Pagination :params="pagin" @pageBind="getList"></Pagination>
        </div>
    </div>
</template>

<script>
    import Pagination from '@/components/Pagination';
    export default {
        name: 'admin',
        data() {
            return {
                firmId:'',
                devId:'',
                firmType: '',
                firmVersion: '',
                data: [],
                pagin: {
                    pageNum: 1,
                    pageSize: 20,
                    total: 0,
                },
                typeList:[],
            }
        },
        created() {
            if(this.$route.params.id) {
                this.firmId = this.$route.params.id;
                this.$http.get('/manage/firmLora/types').then(data=> {
                    this.typeList = data['data']['data'];
                });
            }else{
                this.$router.push('/firmware/lora/index');
            }
        },
        filters:{
            status(value) {
                switch(value) {
                    case '0': return '待升级';break;
                    case '1': return '待升级';break;
                    case '2': return '升级中';break;
                    case '3': return '已完成';break;
                }
            }
        },
        methods: {
            search() {//搜索
                this.pagin.pageNum = 1;
                this.getList();
            },
            getList() {
                //数据绑定
                let params = {
                    firmId: this.firmId,
                    pageNum: this.pagin.pageNum,
                    pageSize: this.pagin.pageSize,
                }
                if(this.devId.trim() != '') {
                    params.devId = this.devId;
                }
                if(this.firmType.trim() != '') {
                    params.firmType = this.firmType;
                }
                if(this.firmVersion.trim() != '') {
                    params.firmVersion = this.firmVersion;
                }
                this.$http.post('/manage/firmLora/upHis',params).then(results => {
                    this.data = results['data']['data']['records'];
                    this.pagin.total = results['data']['data']['total'];
                });
            },
        },
        components: { Pagination }
    }
</script>